/**
 * BaseState - Base class for all player states
 * Override enter(), exit(), and update() in derived states
 */

export default class BaseState {
    constructor() {
        this.stateMachine = null;
        this.owner = null; // Will be set to Player instance
    }

    /**
     * Called when entering this state
     * @param {Object} data - Optional data passed from previous state
     */
    enter(data = null) {
        // Override in derived class
    }

    /**
     * Called when exiting this state
     */
    exit() {
        // Override in derived class
    }

    /**
     * Called every frame while in this state
     * @param {number} delta - Delta time in ms
     */
    update(delta) {
        // Override in derived class
    }

    /**
     * Transition to another state
     * @param {string} stateName - Name of state to transition to
     * @param {Object} data - Optional data to pass
     */
    transitionTo(stateName, data = null) {
        if (this.stateMachine) {
            this.stateMachine.setState(stateName, data);
        }
    }

    /**
     * Get the player instance
     */
    get player() {
        return this.owner;
    }

    /**
     * Get the scene
     */
    get scene() {
        return this.owner?.scene;
    }

    /**
     * Get the player sprite
     */
    get sprite() {
        return this.owner?.sprite;
    }

    /**
     * Clean up
     */
    destroy() {
        this.stateMachine = null;
        this.owner = null;
    }
}
